<!-- KYMW4401 コピー設定 -->
<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">コピー設定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <h2>コピー元</h2>
          <div class="column-list">
            <!-- 媒体 コピー元 -->
            <label class="list-input-title">媒体</label>
            <div class="list-input-content">
              <input type="text" readonly [value]="model.dspMediumType" [style.width.px]="230"/>
            </div>
            <!-- 受注コード コピー元 -->
            <label class="list-input-title">受注コード</label>
            <div class="list-input-content">
              <app-order-text-with-catalog [autofocus]="true" [required]="true" [tabindex]="0"
                [forcedEnabledMode]="'true'" [(ngModel)]="model.orderCodeOrigin" width="100"
                (onChangedCatalogId)="model.catalogIdOrigin = $event">
              </app-order-text-with-catalog>
            </div>
            <!-- 企画回 コピー元 -->
            <label class="list-input-title">企画回</label>
            <div class="list-input-content">
              <app-catalog-text-with-order [autofocus]="true" [required]="true" [tabindex]="0"
                [forcedEnabledMode]="'true'" [(ngModel)]="model.catalogIdOrigin" width="100"
                (onChangedOrderCode)="model.orderCodeOrigin = $event">
              </app-catalog-text-with-order>
            </div>
            <!-- 会員生協 コピー元 -->
            <label class="list-input-title">会員生協</label>
            <div class="list-input-content">
              <app-coop-code-combo-box #cmb_CoopCode width="230" [required]="true" [forcedEnabledMode]="'true'"
                [(ngModel)]="model.coopCode" [tabindex]="0"></app-coop-code-combo-box>
            </div>
          </div>
        </div>

        <div>
          <h2>コピー先</h2>
          <div class="column-list">
            <!-- 媒体 コピー先 -->
            <label class="list-input-title">媒体</label>
            <div class="list-input-content">
              <input type="text" readonly [value]="model.dspMediumType" [style.width.px]="230"/>
            </div>
            <!-- 受注コード コピー先 -->
            <label class="list-input-title">受注コード</label>
            <div class="list-input-content">
              <app-order-text-with-catalog [autofocus]="true" [required]="true" [tabindex]="0"
                [forcedEnabledMode]="'true'" [(ngModel)]="model.orderCodeFromCopy" width="100"
                (onChangedCatalogId)="model.catalogIdFromCopy = $event">
              </app-order-text-with-catalog>
              &#65374;
              <app-order-text-with-catalog [autofocus]="true" [required]="true" [tabindex]="0"
                [forcedEnabledMode]="'true'" [(ngModel)]="model.orderCodeToCopy" width="100"
                (onChangedCatalogId)="model.catalogIdToCopy = $event">
              </app-order-text-with-catalog>
            </div>
            <!-- 企画回 コピー先 -->
            <label class="list-input-title">企画回</label>
            <div class="list-input-content">
              <app-catalog-text-with-order [autofocus]="true" [required]="true" [tabindex]="0"
                [forcedEnabledMode]="'true'" [(ngModel)]="model.catalogIdFromCopy" width="100"
                (onChangedOrderCode)="model.orderCodeFromCopy = $event">
              </app-catalog-text-with-order>
              &#65374;
              <app-catalog-text-with-order [autofocus]="true" [required]="true" [tabindex]="0"
                [forcedEnabledMode]="'true'" [(ngModel)]="model.catalogIdToCopy" width="100"
                (onChangedOrderCode)="model.orderCodeToCopy = $event">
              </app-catalog-text-with-order>
            </div>
            <!-- 会員生協 コピー先 -->
            <label class="list-input-title">会員生協</label>
            <div class="list-input-content">
              <input type="text" readonly [value]="dspCoopCode()" [style.width.px]="230"/>
            </div>
          </div>
        </div>
      </div><!-- div contents-area END -->
    </td>
  </tr>

  <!-- フッター -->
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <!-- button 設定 -->
          <button #btn_Set class="btn-primary" (click)="set()" [tabindex]="0" forcedEnabledMode="true">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>

</table>